import { axiosWithAuth } from "./../../helpers";

export const merchantStatementTabService = {
	getStatementList,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getStatementList({ merchantId, page, sortBy }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/merchants/${merchantId}/statements`,
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			sort_type: sortBy?.year || undefined,
			ascending: sortBy?.year ? sortBy?.desc : undefined,
		},
	};

	return axiosWithAuth(options);
}
